module.exports = require("core-js-pure/features/set-interval");